import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CardWebComponent, IconWebComponent } from '@resident-nx/web/ui';
import { TranslateModule } from '@ngx-translate/core';
import { ImmomioIconName } from '@resident-nx/shared';

@Component({
  standalone: true,
  selector: 'rs-web-ticket-information-notice',
  imports: [CardWebComponent, IconWebComponent, TranslateModule],
  templateUrl: './ticket-information-notice.component.html',
  styleUrl: './ticket-information-notice.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketInformationNoticeComponent {
  protected readonly ImmomioIconName = ImmomioIconName;
}
